import { createReducer, on } from '@ngrx/store';
import { User } from '../../models/user.model';
import { loggedUserActions } from './logged_user.actions';

export const initialState: User|Object = {};

export const loggedUserReducer = createReducer(
    initialState,
    on(loggedUserActions.setLoggedUser, (state, {data}) => data),
    on(loggedUserActions.resetLoggedUser, (state) => initialState)
)